//import produce from "immer";
import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { getFieldInstance, getStandardInstance } from "./utils";

export default function formReducer(state = initialState.form, action) {
  switch (action.type) {
    case types.SET_FORM_TITLE: {
      const { title } = action.payload;
      return { ...state, title };
    }
    case types.SET_FORM_DESCRIPTION: {
      const { description } = action.payload;
      return { ...state, description };
    }
    case types.SET_DROPPED: {
      const field = getFieldInstance(action.droppedItem.type);
      const updateStandardField = getStandardInstance(
        field,
        state.standardFields
      );
      return {
        ...state,
        dropped: [...state.dropped, field],
        standardFields: {
          ...state.standardFields,
          [field.type]: updateStandardField,
        },
      };
    }
    case types.UPDATE_DROPPED_ITEMS: {
      return { ...state, dropped: [...action.dropped] };
    }
    case types.REMOVE_DROP_ITEM: {
      console.log("REMOVE_DROP_ITEM==>", action);
      const cloneFocusField = { ...state.focusField };
      const isCurrentlyEditing = action.uid == cloneFocusField.uid;
      const filterDropItems = state.dropped.filter(
        (field) => field.uid != action.uid
      );
      const standardFields = JSON.parse(
        JSON.stringify({
          ...state.standardFields,
        })
      );
      let findTypeAndIndex = [];
      Object.keys(standardFields).map((type) => {
        standardFields[type].filter((field) => {
          if (field.uid != action.uid) {
            findTypeAndIndex.push(field);
          }
        });
      });
      let updateStandardFields = {
        textField: [],
        url: [],
        paragraph: [],
        number: [],
        dropDown: [],
        checkBox: [],
        rating: [],
      };
      findTypeAndIndex.map((field) => {
        updateStandardFields[field.type].push(field);
      });

      const updateFocusField = isCurrentlyEditing ? {} : cloneFocusField;
      return {
        ...state,
        dropped: filterDropItems,
        standardFields: updateStandardFields,
        isEditing: !isCurrentlyEditing,
        focusField: updateFocusField,
      };
    }
    case types.SET_EDITING_MODE: {
      const { fieldId, fieldType } = action.payload;
      if (fieldType == "BUTTON") {
        return {
          ...state,
          focusField: { ...state.submitConfig },
          isEditing: true,
        };
      }
      const findField = state.dropped.find((field) => field.uid == fieldId);
      return { ...state, focusField: findField, isEditing: true };
    }
    case types.UPDATE_FIELD: {
      const { updateField, fieldType } = action.payload;
      console.log("action!!", action);
      if (fieldType == "BUTTON") {
        return {
          ...state,
          focusField: updateField,
          submitConfig: updateField,
          isEditing: true,
        };
      }
      console.log("updateField", updateField);
      const findFieldIndex = state.dropped.findIndex(
        (field) => field.uid == updateField.uid
      );
      const updateDroppedItems = [...state.dropped];
      updateDroppedItems[findFieldIndex] = updateField;

      const standardFields = JSON.parse(
        JSON.stringify({
          ...state.standardFields,
        })
      );
      if (standardFields[updateField.type]) {
        const findStandardFieldIndex = standardFields[
          updateField.type
        ].findIndex((field) => field.uid == updateField.uid);
        standardFields[updateField.type][findStandardFieldIndex] = updateField;
      }
      return {
        ...state,
        dropped: updateDroppedItems,
        standardFields,
        focusField: updateField,
      };
    }
    case types.DISABLE_EDITING_MODE: {
      return { ...state, focusField: {}, isEditing: false };
    }
    case types.UPDATE_ENTIRE_FORMS: {
      const { title, description, fields, submitBtnConfig } = action.payload;
      const contactFields = [];
      const standardFields = JSON.parse(
        JSON.stringify({
          ...state.standardFields,
        })
      );
      const CONTACT_FIELDS = [
        "firstName",
        "lastName",
        "phone",
        "email",
        "address",
      ];
      action.payload.fields.map((field) => {
        if (CONTACT_FIELDS.indexOf(field.type) != -1) {
          contactFields.push(field);
        } else {
          standardFields[field.type].push(field);
        }
      });
      return {
        ...state,
        title,
        description,
        dropped: [...fields],
        standardFields,
        submitConfig: { ...submitBtnConfig },
      };
    }
    default:
      return state;
  }
}

// export default function formReducer(state = initialState.form, action) {
//   return produce(state, (draft) => {
//     switch (action.type) {
//       case types.SET_FORM_TITLE: {
//         const { title } = action.payload;
//         draft.title = title;
//         break;
//       }
//       case types.SET_FORM_DESCRIPTION: {
//         const { description } = action.payload;
//         draft.description = description;
//         break;
//       }
//       case types.SET_DROPPED: {
//         const field = getFieldInstance(action.droppedItem.type);
//         draft.dropped.push(field);
//         break;
//       }

//       case types.UPDATE_DROPPED_ITEMS: {
//         draft.dropped.push();
//         break;
//       }
//       case types.REMOVE_DROP_ITEM: {
//         const cloneFocusField = { ...state.focusField };
//         const isCurrentlyEditing = action.uid == cloneFocusField.uid;
//         const filterDropItems = state.dropped.filter(
//           (field) => field.uid != action.uid
//         );
//         const updateFocusField = isCurrentlyEditing ? {} : cloneFocusField;
//         draft.dropped.push(filterDropItems);
//         draft.isEditing.push(isCurrentlyEditing);
//         draft.focusField.push(updateFocusField);
//         break;
//       }
//       case types.SET_EDITING_MODE: {
//         const { fieldId, fieldType } = action.payload;
//         if (fieldType == "BUTTON") {
//           draft.focusField = { ...state.submitConfig };
//           draft.isEditing = true;
//           break;
//         }
//         const findField = state.dropped.find((field) => field.uid == fieldId);
//         draft.focusField = findField;
//         draft.isEditing = true;
//         break;
//       }
//       case types.UPDATE_FIELD: {
//         const { updateField, fieldType } = action.payload;
//         if (fieldType == "BUTTON") {
//           draft.focusField = updateField;
//           draft.submitConfig = updateField;
//           draft.isEditing = true;
//           break;
//         }

//         const findFieldIndex = state.dropped.findIndex(
//           (field) => field.uid == updateField.uid
//         );
//         const updateDroppedItems = [...state.dropped];
//         updateDroppedItems[findFieldIndex] = updateField;
//         draft.dropped = updateDroppedItems;
//         draft.focusField = updateField;
//         break;
//       }
//       case types.DISABLE_EDITING_MODE: {
//         draft.focusField = {};
//         draft.isEditing = false;
//         break;
//       }
//       case types.UPDATE_ENTIRE_FORMS: {
//         const { title, description, fields, submitBtnConfig } = action.payload;

//         draft.title = title;
//         draft.description = description;
//         draft.dropped = [...fields];
//         draft.submitConfig = { ...submitBtnConfig };
//         break;
//       }
//       default:
//         return state;
//     }
//   });
// }
